import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetBannerDetails } from '../../../hooks/banners';

import { IBannerFormData } from '../../../interfaces/banners';

import { BannerDetailsLayout } from '../../layouts/Banners';
import { BannerDetailsForm } from '../../sub_components/forms/BannerDetails';

const BannerSavePage = () => {
    const { banner_id } = useParams();

    const [bannerId, setBannerId] = useState<number | null>(null);

    const [formData, setFormData] = useState<IBannerFormData>({
        id: null,
        title: { value: "", error: "" },
        description: { value: "", error: "" },
    });

    const { data: banner, isLoading, error } = useGetBannerDetails(bannerId);

    useEffect(() => {
        if (banner_id) {
            setBannerId(Number(banner_id));
        };
    }, [banner_id]);

    return (
        <BannerDetailsLayout
            title={bannerId ? (banner?.title ?? 'Banner') : 'Create Banner'}
            error={!!error}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className="immersion__common_details__sub_info_view">
                    <div className="immersion__common_details__sub_info__forms_container">
                        <div className="immersion__banner_details__page_view">
                            <div className="immersion__common_details__layout">
                                <div className="immersion__common_details__content">
                                    <BannerDetailsForm
                                        operation={bannerId ? 'update' : 'create'}
                                        isLoading={isLoading}
                                        bannerData={banner ?? null}
                                        formData={formData}
                                        setFormData={setFormData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BannerDetailsLayout>
    );
};

export default BannerSavePage;